import { render, staticRenderFns } from "./record_edit.vue?vue&type=template&id=82b34e2a&scoped=true"
import script from "./record_edit.vue?vue&type=script&lang=js"
export * from "./record_edit.vue?vue&type=script&lang=js"
import style0 from "./record_edit.vue?vue&type=style&index=0&id=82b34e2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b34e2a",
  null
  
)

export default component.exports